<div class="multisearch">
  <!-- Criteria Selection  [nzLabel]="commonUtility.splitCamelCaseAndApplyReplacements(criteria.keyDescription)"-->
  <div class="multisearch-grid" *ngFor="let row of rows; let i = index;">
    <nz-select nzShowSearch nzAllowClear [(ngModel)]="row.selectedCriteriaKey" [disabled]="row.isMandatory"
      (ngModelChange)="criteriaSelected(row.selectedCriteriaKey, i)" style="width: 100%;"
      nzPlaceHolder="{{'Select Value' | translate}}">
      <ng-container *ngFor="let criteria of SearchCriteria; let criteriaIndex = index;">
        <nz-option *ngIf="criteria.enable" [nzLabel]="criteria.keyDescription" [nzValue]="criteria.key"
          [nzHide]="isSearchCriteriaAlreadySelected(criteria.key)"></nz-option>
      </ng-container>
    </nz-select>
    <div class="pos-relative">
      <ng-container *ngIf="!checkWhetherExternalCriteria(row.selectedCriteriaKey); else preselectedMandatoryData">
        <!-- Input -->
        <nz-select nzShowSearch *ngIf="row.valueInputType === 'LOOKUP'" style="width: 100%" nzAllowClear
          nzPlaceHolder="{{'Select' | translate}}" [(ngModel)]="row.selectedValue" (ngModelChange)="showSearchOptions($event)">
          <nz-option *ngFor="let item of row.lookup; let lookupIndex = index;" [nzValue]="item.lookupKey"
            [nzLabel]="item.lookupValue"></nz-option>
        </nz-select>
        <div style="display: flex;">
          <nz-date-picker *ngIf="row.valueInputType == 'DATE'" style="width: 100%;margin-right: 5px"  [(ngModel)]="row.fromDate" 
          [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR"  
          nzPlaceHolder="From Date (DD Mmm YYYY)" 
          (ngModelChange)="showSearchOptions($event)"
          ></nz-date-picker>
          <nz-date-picker *ngIf="row.valueInputType == 'DATE'" style="width: 100%;margin-right: 5px"  [(ngModel)]="row.toDate" 
          [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR"  
          nzPlaceHolder="To Date (DD Mmm YYYY)" 
          (ngModelChange)="showSearchOptions($event)"
          ></nz-date-picker>
        </div>
        <!-- Input filed (resets and changes based on dropdown selection) -->
        <input *ngIf="row.valueInputType != 'LOOKUP' && row.valueInputType != 'DATE'" [disabled]="!row.valueInputType" type="text" nz-input
          placeholder="{{'Start Typing...' | translate}}" [(ngModel)]="row.selectedValue"
          (ngModelChange)="modelChanged($event)" (paste)="onPaste($event)" />
        <span *ngIf="row.isMandatory" class="ms-is-mandatory">*</span>
      </ng-container>
      <ng-template #preselectedMandatoryData>
        <nz-tag style="padding: 5px;width: 100%;" [nzColor]="'geekblue'">Default Value:
          {{checkWhetherExternalCriteria(row.selectedCriteriaKey)? (checkWhetherExternalCriteria(row.selectedCriteriaKey).paramValue | technicalTranslate) : '-'}}
        </nz-tag>
      </ng-template>
    </div>
    <!-- Button Add row -->
    <button *ngIf="i === 0 && dropdownType != 'single'" nz-button nzType="dashed" [disabled] ="maxSearchCriteriaLength == rows.length" (click)="addRow()">
      <i nz-icon nzType="plus" nzTheme="outline"></i>
    </button>
    <!-- Button Remove row -->
    <button style="color: red;" *ngIf="i !== 0 && !row.isMandatory" nz-button nzType="dashed" nz-popconfirm
    nzPopconfirmTitle="{{'Remove this row?' | translate}}" nzOkText="{{'Remove' | translate}}"
      nzCancelText="{{'Cancel' | translate}}" (nzOnConfirm)="removeRow(i)">
      <i nz-icon nzType="delete" theme="outline"></i>
    </button>
  </div>
  <!-- Search Button Pallette Section -->
  <div *ngIf="toggleSearchButtonDisplay" class="multisearch-grid">
    <div class="grid grid-2x grid-gap-10">
    <!-- Button Add row (FIRST ROW WILL HAVE THIS) -->
      <button (click)="searchAndEmitResult()" nz-button nzType="primary" [nzLoading]="searchAndEmitResultLoading">
        {{'Search' | MMSTranslate}}
      </button>
      <!-- <span (click)="resetResult()" style="margin-left: 20px;"> <strong>Clear All</strong></span> -->
      <button style="color: red;" (click)="resetResult()" nz-button nzType="default">
        <span nz-icon nzType="delete" nzTheme="outline"></span> {{'Reset' | MMSTranslate}}
      </button>
    </div>
    <div></div>
    <div></div>
  </div>
</div>
